module.exports = __webpack_public_path__ + "static/media/successfullySendImg.09f3ffc3.png";